import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import HomePage from './HomePage';
import Login from './Login';
import Signup from './SignUp';
import AdminProtectedRoute from './admin/AdminProtectedRoute';
import CreateWorkflow from './admin/Workflows/CreateWorkflow';
import ShowAllWorkflows from './admin/Workflows/ShowAllWorkflows';
import PendingApprovals from './PendingApprovals';
import AdminHome from './admin/AdminHome';
import FormBuilder from './admin/Forms/FormCreation/FormBuilder';
import ShowAllForms from './admin/Forms/ShowAllForms';
import FormDetails from './admin/Forms/FormDetails';
import UserHome from './UserHome';
import ShowForms from './ShowForms';
import ShowFormStatus from './ShowFormStatus';
import ShowForm from './ShowForm';
import PendingFormDetails from './PendingFormDetails';
import AdminDefaultPage from './admin/AdminDefaultPage';
import UserDefaultPage from './UserDefaultPage';
import UserManagement from './admin/UserManagent';
import ProtectedRoute from './ProtectedRoute';
import NotAuthorized from './NotAuthorized';
import store from './admin/store/store';
import { Provider } from 'react-redux';
import { ReactFlowProvider } from 'reactflow';
import ShowWorkflow from './admin/Workflows/ShowWorkflow';
import WorkflowFlowView from './WorkFlowView';

function App() {
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/admin/*"
            element={
              <AdminProtectedRoute>
                <Provider store={store} >
                  <AdminHome />
                </Provider>
              </AdminProtectedRoute>
            }
          >
            <Route index element={<AdminDefaultPage />} />
            <Route path="forms/create" element={<FormBuilder />} />
            <Route path="forms/all" element={<ShowAllForms />} />
            <Route path="forms/:id" element={<FormDetails />} />
            <Route 
              path="workflows/create" 
              element={
                <ReactFlowProvider>
                  <CreateWorkflow />
                </ReactFlowProvider> 
              }
            />
            <Route path="workflows/all" element={<ShowAllWorkflows />} />
            <Route path="workflows/:id" element={<ShowWorkflow />} />
            <Route path="user-management" element={<UserManagement />}/>
          </Route>
          <Route
            path="/user/*"
            element={
              <ProtectedRoute>
                <UserHome />
              </ProtectedRoute>
            }
          >
            <Route index element={<UserDefaultPage />}/>
            <Route path="forms" element={<ShowForms />}/>
            <Route path="forms/:id" element={<ShowForm />} />
            <Route path="show-form-status" element={<ShowFormStatus />} />
            <Route path="show-form-status/:id" element={<WorkflowFlowView />} />
            <Route path="pending-approvals" element={<PendingApprovals />} />
            <Route path="pending-approvals/:id" element={<PendingFormDetails />} />
          </Route>
          <Route path='/not-authorized' element={<NotAuthorized />} />
          <Route path="*" element={<Navigate to="/not-authorized" />} />
        </Routes>
      </Router>
    </SnackbarProvider>
  );
}

export default App;
